module.exports = __webpack_public_path__ + "img/loading.7712547a.jpeg";